import React, { createContext, useContext, useState } from 'react';
import { Option } from 'options';

type SelectionContextType = {
  selection: Option | null;
  setSelection: (val: Option | null) => void;
}

const initialContext: SelectionContextType = {
  selection: null,
  setSelection: (val: Option | null) => {}
};

const SelectionContext = createContext<SelectionContextType>(initialContext);
const useSelectionContext = () => useContext(SelectionContext);

const SelectionContextProvider = ({ children }: { children: any }) => {
  const [selection, setSelection] = useState<null | Option>(null);

  return (
    <SelectionContext.Provider value={{ selection, setSelection }}>
      {children}
    </SelectionContext.Provider>
  )
};

export { SelectionContextProvider, useSelectionContext };